import React from 'react'
import { connect } from 'react-redux'
import { setUserPreferenceState } from '../../../../../action/user-preferences'
import entries from './entries.json'
import { makeProductionTrue, makeProductionFalse } from '../../../../../action/production-action'
import { showZoomLevel, hideZoomLevel } from '../../../../../action/zoom-level-toggle-action'
import { showGearDropMarkers, hideGearDropMarkers, fetchGearDropMarkers } from '../../../../../action/gear-drop-actions'

const GEAR_DROP_WHITELIST = ['jeffreybalch@basemap.com', 'matt.habiger@basemap.com']

class Units extends React.Component {
  constructor(props) {
    super(props)
    this.state = { loading: false }
  }

  makeEntries() {
    return entries.entries.map((entry, idx) => {
      const header = entry[0],
        content = entry[1]
      return (
        <div key={`setting-entry-${idx}`} style={{ marginBottom: '5px', display: 'flex', flexDirection: 'column' }}>
          <div className='settings-entry-header' key={`setting-header-${idx}`}>{header}</div>
          {
            content.map((strs, sidx) => {
              return (
                <div key={`setting-content-${idx}-${sidx}`} className='settings-entry-row'>
                  <p style={{ width: '165px' }}>{strs[0]}</p>
                  <p style={{ width: '165px' }}>{strs[1]}</p>
                </div>
              )
            })
          }
        </div>
      )
    })
  }

  handleProductionLayer = () => {
    if (this.props.productionLayers) {
      this.props.makeProductionFalse()
    } else {
      this.props.makeProductionTrue()
    }
  }

  handleGearDropToggle = () => {
    if (this.props.showGearDrop) {
      this.props.hideGearDropMarkers()
    } else {
      this.setState({ loading: true })
      this.props.fetchGearDropMarkers()
        .then(() => {
          this.props.showGearDropMarkers()
        })
        .catch(err => {
          console.error('Failed to fetch gear drop markers:', err)
        })
        .finally(() => {
          this.setState({ loading: false })
        })
    }
  }

  handleZoomLevel = () => {
    if (!this.props.zoomLevel) {
      this.props.showZoomLevel()
    } else {
      this.props.hideZoomLevel()
    }
  }

  render() {
    const { units } = this.props.userPreferences,
      { setUserPreferenceState, productionLayers, zoomLevel, showGearDrop, user } = this.props
    const { loading } = this.state
    const isAdmin = user && user.roleId === 0
    return (
      <div style={{
        height: `calc(100vh - 60px - 90px - 60px - 20px)`,
        // overflowY: 'scroll', overflowX: 'hidden',
        width: 350
      }}>

        {loading &&
          <div style={{ position: 'fixed', top: '50%', left: '50%' }}>
            <div className="loader-spinner" style={{}}></div>
          </div>
        }




        <div className='settings-units-container'>
          <h2 style={{ textOverflow: 'ellipsis' }}>Units of Measurement</h2>
          <div className='settings-input-row'>
            <div style={{ width: '165px' }}>
              <input type='radio' id='imperial' name='imperial' checked={units === 'imperial'}
                onChange={() => {
                  if (units !== 'imperial') {
                    setUserPreferenceState({ units: 'imperial' })
                    this.forceUpdate()
                  }
                }}
              />
              <label htmlFor='imperial'>Imperial</label>
            </div>
            <div style={{ width: '165px' }}>
              <input type='radio' id='metric' name='metric' checked={units === 'metric'}
                onChange={() => {
                  if (units !== 'metric') {
                    setUserPreferenceState({ units: 'metric' })
                    this.forceUpdate()
                  }
                }}
              />
              <label htmlFor='metric'>Metric</label>
            </div>
          </div>
          <div>
            {this.makeEntries()}
          </div>
        </div>
        <div style={{}}>
          {__NODE_ENV__ != 'production' ?
            <div style={{ margin: '0.25rem 2rem 0.25rem 2rem', width: '80%', height: '30%', border: '2px solid #959595', borderRadius: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div className='togle-botton'>
                <label>Show Only Production Layers:</label>
                <input type='checkbox' checked={productionLayers} onChange={() => { this.handleProductionLayer() }} style={{ width: 20, height: 15 }}></input>
              </div>
            </div> : null
          }
          {__NODE_ENV__ != 'production' ?
            <div style={{ margin: '1rem 2rem 1rem 2rem', width: '80%', height: '30%', border: '2px solid #959595', borderRadius: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div className='togle-botton'>
                <label>Zoom Level:</label>
                <input type='checkbox' checked={zoomLevel} onChange={() => { this.handleZoomLevel() }} style={{ width: 20, height: 15 }}></input>
              </div>
            </div> : null
          }

          {/* {__NODE_ENV__ != 'production' ? */}
          {user && GEAR_DROP_WHITELIST.includes(user.email) ?
            <div style={{ margin: '0.25rem 2rem 0.25rem 2rem', width: '80%', height: '30%', border: '2px solid #959595', borderRadius: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div className='togle-botton'>
                <label>Show Gear Drop Markers:</label>
                <input type='checkbox' checked={showGearDrop} onChange={() => { this.handleGearDropToggle() }} style={{ width: 20, height: 15 }}></input>
              </div>
            </div> : null
          }
        </div>
      </div>
    )
  }
}


const mapStateToProps = state => ({
  userPreferences: state.userPreferences,
  productionLayers: state.productionLayers,
  zoomLevel: state.zoomLevel,
  showGearDrop: state.gearDrop.show,
  user: state.user,
})

const mapDispatchToProps = dispatch => ({
  setUserPreferenceState: preferences => { dispatch(setUserPreferenceState(preferences)) },
  makeProductionTrue: () => dispatch(makeProductionTrue()),
  makeProductionFalse: () => { dispatch(makeProductionFalse()) },
  showZoomLevel: () => dispatch(showZoomLevel()),
  hideZoomLevel: () => dispatch(hideZoomLevel()),
  showGearDropMarkers: () => dispatch(showGearDropMarkers()),
  hideGearDropMarkers: () => dispatch(hideGearDropMarkers()),
  fetchGearDropMarkers: () => dispatch(fetchGearDropMarkers()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Units)